import { configureStore } from "@reduxjs/toolkit";
import { AuthReducer } from "./Auth";
import { CustomerReducer } from "./Customer";
import { PopupReducer } from "./PopupModal";
import { TemplateReducer } from "./Template";

export const store = configureStore({
  reducer: {
    Auth: AuthReducer,
    Customer: CustomerReducer,
    Popup: PopupReducer,
    Templates: TemplateReducer,
  },
  devTools: process.env.NODE_ENV === "development",
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
